<template>
  <div id="app">
    <!-- <div style="width: 100%;"><a href="https://www.zgmlxc.com.cn" class="a-block" target="_blank"><img src="./assets/img/beautifulCountry2022.jpg" alt="2022美丽乡村博鳌国际峰会" style="display: block;width: 100%;"></a></div> -->
    <!-- <div style="width: 100%;"><a href="http://www.cngongji.cn/" class="a-block" target="_blank"><img src="http://www.news.cn/2021homepro/images/20211210_gjgjr_v1.jpg" alt="国家公祭日" style="display: block;width: 100%;"></a></div> -->
    <!-- <div style="width: 100%;"><img src="http://yjy.goodwebuy.cn/rmzd/news/img/100.jpg" style="display: block;width: 100%;" alt="庆祝中国共产党成立100周年"></div> -->
    <!-- <div style="width: 100%;background-color: #FFFFFF;"><a href="https://www.cnas.org.cn/rdzt/2022nsjrkr/index.shtml" class="a-block" target="_blank"><img src="./assets/img/worldSure.jpg" style="display: block;width: 100%;" alt="2022年世界认可日"></a></div> -->
    <!-- <Top v-show="($route.name!=='FooterLinks') && ($route.name!=='OpenScreen')"></Top> -->
    <Top v-if="($route.name!=='FooterLinks') && ($route.name!=='OpenScreen') && ($route.meta.pageType!='secondChannel') && ($route.meta.isPicChannel!='yes')"></Top>
    <PicTop v-if="$route.meta.isPicChannel=='yes'"></PicTop>
    <PicHeader v-if="$route.meta.isHeader=='picHeader'"></PicHeader>
    <!-- <Header v-show="($route.name!=='FooterLinks') && ($route.name!=='OpenScreen') && ($route.name!=='peopleLearn')"></Header> -->
    <Header v-if="($route.name!=='FooterLinks') && ($route.name!=='OpenScreen') && ($route.name!=='peopleLearn') && ($route.meta.pageType!='secondChannel') && ($route.meta.isPicChannel!='yes')"></Header>
    <router-view></router-view>
    <Footer v-if="$route.name!=='OpenScreen'"></Footer>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import Top from '@/components/Top.vue'
  import PicTop from '@/components/PicTop.vue'
  import PicHeader from '@/components/PicHeader.vue'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  // import datas from '@/api/datas'
  import VueUeditorWrap from '@/components/vue-ueditor-wrap.vue'
  Vue.component('vue-ueditor-wrap', VueUeditorWrap)

  // window.UEDITOR_HOME_URL = '/static/UEditor/'

  import Vue from "vue";
  export default {
    name: 'App',
    data() {
      return {
        title: '',
        // 监听,广播数据  不关联组件之间数据传递
        eventHub: new Vue(),
      }
    },
    provide() {
      return {
        eventHub: this.eventHub
      };
    },
    components:{
      Top,
      PicTop,
      PicHeader,
      Header,
      Footer,
      // datas
    }

  }

</script>


<style lang="less">
  @import "./assets/style/public";
  @import "./assets/ttf/iconfont.css";
  @import "./assets/style/vue-snotify/styles/material.css";
  #app {
    background-color: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue